import * as React from "react";
import { DropdownInput } from "../../components/forms";

interface IPickListOption {
	text: string;
	value: string;
}
const defaultPickListOptions: IPickListOption[] = [
	{
		text: "",
		value: "",
	},
];

interface IProps {
	// passed props
	value: string;
	onChange: (e: any) => void;
	labelText?: string;
	name: string;
	className?: string;
	required?: boolean;
	pickListCode: string;
	// own props
	pickListItems: PickListItemResponseDTO[];
}

class PickListDropdown extends React.Component<IProps> {
	private pickListOptions = defaultPickListOptions;
	constructor(props: IProps) {
		super(props);
		this.pickListOptions = this.props.pickListItems.map(
			(p: PickListItemResponseDTO) => {
				return { text: p.description!, value: p.id!.toString() };
			}
		);
	}

	public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
		this.pickListOptions = nextProps.pickListItems.map(
			(p: PickListItemResponseDTO) => {
				return { text: p.description!, value: p.id!.toString() };
			}
		);
	}

	public render() {
		return (
			<DropdownInput
				labelText={this.props.labelText}
				name={this.props.name}
				defaultOption="-"
				options={this.pickListOptions}
				onChange={this.props.onChange}
				value={this.props.value}
				className={this.props.className}
				required={this.props.required}
			/>
		);
	}
}

export default PickListDropdown;
